import {ScreenDetectorFactory} from "./ScreenDetectorFactory";

const mobileBreakPoint = 1024;
const mobileCallback = () => {
    return window.innerWidth < mobileBreakPoint;
    // return window.innerWidth < mobileBreakPoint && window.innerWidth < window.innerHeight;
};

export const DefaultScreenDetector = ScreenDetectorFactory.create(mobileCallback);
